module.exports = __webpack_public_path__ + "img/374.2f22ed98.jpg";